export const CALENDAR_DAY_SLOT_COUNT = 48
export const CALENDAR_DAY_SLOT_DURATION_MINUTES = 30
export const CALENDAR_DAY_SLOT_HEIGHT_PX = 30
export const CALENDAR_DAY_EVENT_MAX_WIDTH_PX = 260
